/* eslint-disable no-unused-vars */
import Swiper, {Autoplay, Pagination} from 'swiper';

Swiper.use([Pagination, Autoplay]);

const customRenderBullet = (index, className) => '<span class="' + className + '"></span>';

const headerSliderWrapper = document.getElementById('header-slider');
if (headerSliderWrapper && headerSliderWrapper.querySelectorAll('.swiper-slide').length > 1) {
  const headerSlider = new Swiper('#header-slider', {
    autoplay: {
      delay: 4000
    },
    loop: true,
    watchOverflow: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: customRenderBullet
    }
  });
} else if(headerSliderWrapper) {
  headerSliderWrapper.classList.add('single-slide');
}

const cardSlider = new Swiper('#card-slider', {
  loop: true,
  autoplay: {
    delay: 4000
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    renderBullet: customRenderBullet
  }
});

const testimonialSlider = new Swiper('#testimonial-slider', {
  spaceBetween: 20,
  slidesPerView: 1,
  breakpoints: {
    640: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3
    }
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    renderBullet: customRenderBullet
  }
});

const pageSlider = new Swiper('#page-slider', {
  spaceBetween: 20,
  slidesPerView: 1,
  watchOverflow: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    renderBullet: customRenderBullet
  }
});
